import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.UploadProductEnhancementDocument.IRequest;
type Response = Api.Core.DealerGroup.UploadProductEnhancementDocument.IResponse;
type Headers = Api.Core.DealerGroup.UploadProductEnhancementDocument.IHeaders;
const apiDealerGroupUploadProductDocumentPath =
  '/api/DealerManagement/DealerGroup/:id/UploadProductEnhancementDealerGroupDocument/:productEnhancementId/:productEnhancementDocumentId';
export default async function dealerGroupUploadProductEnhancementDocumentApi(
  params: { id: number; productEnhancementId: number; productEnhancementDocumentId: number },
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiDealerGroupUploadProductDocumentPath, params),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
